import React from "react";
import { DataUtils, ImageDescriptorData, TeamRoles } from "../clients/data-service";
import { GroupBy, OrderBy } from "../utilities/DataTools";
import { DraftImageSubject, ImageSubjectUtilities } from "../utilities/ImageSubjectUtilities";
import { Box, Center, Highlight, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';

export class ImagePeopleListing extends React.Component<{descriptor:ImageDescriptorData, compact?:boolean, playersToHighlight?:string[]}> {
    render () {
        const prepared = ImageSubjectUtilities.draft(this.props.descriptor.subjects);
        ImageSubjectUtilities.fillGaps(prepared);
        const rows = GroupBy(prepared, s=>s.row);
        const maxRow = ImageSubjectUtilities.maxRow(prepared);
        const lines: JSX.Element[] = [];
        for (let row = maxRow; row >= -1; row--) {
            if (rows.has(row)) {
                lines.push(GetRowText(row, rows.get(row)!, row === maxRow, this.props.playersToHighlight ?? [], this.props.compact));
            }
        }

        return (<>
            <Center>
                <VStack spacing='12px'> 
                    {lines}
                </VStack>
            </Center>
        </>);
    }
}

function GetRowText(rowIndex: number, people: DraftImageSubject[], isBackRow: boolean, playersToHighlight:string[], compact?: boolean): JSX.Element {
    let label = "Row " + rowIndex;
    if (isBackRow) {
        label = label + " (Back): ";
    } else if (rowIndex === 1) {
        label = label + " (Front): ";
    } else if (rowIndex === 0) {
        label = "Other: "
    } else if (rowIndex === -1) {
        label = "Absent: ";
    } else {
        label = label + ": ";
    }

    const fontSize = compact ? "sm" : ""
    //return (<Box><Text key={label}>{label}</Text><Text>{OrderBy(people, p => p.column).map(GetSubjectLabel).join(", ")}</Text></Box>); 
    return (<Wrap key={`row_${rowIndex}`} spacingY={0} justify='center' fontSize={fontSize}><WrapItem key="legend"><b>{label}</b></WrapItem>{OrderBy(people, p => p.column).map((s, i, l) => GetSubjectLabel(s, i == l.length - 1, playersToHighlight))}</Wrap>); 
}

function GetSubjectLabel(subject: DraftImageSubject, isLast: boolean, playersToHighlight:string[]) : JSX.Element {
    const role = IfEmpty(subject.role, "Player");
    let name = subject.name;
    if (!subject.name) {
        name = `${role} ${subject.column}`;
    }

    let text = `${name}${role !== "Player" ? ` (${DataUtils.LookupDisplay(TeamRoles(), role)})` : ""}`;
    
    if (!subject.name) {
        return <WrapItem  key={`subject_${subject.id}`}><i>{text}</i>{!isLast && ", "}</WrapItem>
    }

    if (!isLast) {
        text = text + ", ";
    }
    return (
        <WrapItem key={`subject_${subject.id}`}>
            <Highlight query={playersToHighlight} styles={{ px: '1', py: '0', rounded: 'sm', bg: 'green.100' }}>
                {text}
            </Highlight>
        </WrapItem>)
}

function IfEmpty(input: string|undefined, replacement: string) : string {
    if (!input || input.trim().length === 0) {
        return replacement;
    }

    return input;
}
